module.exports = __webpack_public_path__ + "img/q2.7d75bc05.png";